const { datadogRum } = require('@datadog/browser-rum');

// URL-based app name resolution for beforeSend fallback
function resolveAppFromUrl() {
  const path = window.location.pathname;
  if (path.startsWith('/tax')) return 'tax-app';
  if (path.startsWith('/task-manager-bpa')) return 'task-manager-bpa';
  if (path.startsWith('/task-manager')) return 'task-manager';
  if (path.startsWith('/client-management')) return 'client-management';
  if (path.startsWith('/person-management')) return 'person-management';
  return 'flo-dashboard';
}

function initializeDataDogRUM({ applicationId, clientToken }, env = 'staging') {
  if (datadogRum.getInitConfiguration()) {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    env,
    site: 'datadoghq.com',
    service: 'flo-dashboard',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: event => {
      // Tag every event with the active app if not already set via global context
      if (!event.context?.bench_app) {
        event.context = { ...event.context, bench_app: resolveAppFromUrl() };
      }
      return true;
    },
  });

  datadogRum.startSessionReplayRecording();
}

function setDataDogRUMUser(userId) {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.setUser({ id: userId });
}

function setDataDogRUMContext(key, value) {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.setGlobalContextProperty(key, value);
}

function startDataDogRUMView(viewName) {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.startView({ name: viewName });
}

function addFeatureFlagEvaluation(key, value) {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.addFeatureFlagEvaluation(key, value);
}

module.exports = {
  initializeDataDogRUM,
  setDataDogRUMUser,
  setDataDogRUMContext,
  startDataDogRUMView,
  addFeatureFlagEvaluation,
};
